import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { ObjectFit } from '../../types/ObjectFit';
import { WidgetType } from '../../utils/widgetsUtils';

export enum GoToType {
  Page = 'page',
  ExternalLink = 'externalLink'
}

export enum LinkTargetType {
  SameWindow = '_self',
  NewTab = '_blank'
}

export const ImageWidgetStaticSchema = BaseWidgetSchema(WidgetType.Image).extend({
  src: z.string(),
  alt: z.string(),
  mobileSrc: z.string(),
  objectFit: z.nativeEnum(ObjectFit),
  mobileObjectFit: z.nativeEnum(ObjectFit),
  goToLink: z.string(),
  goToLinkTitle: z.string(),
  goToPage: z.string(),
  goToPageTitle: z.string(),
  linkTargetType: z.nativeEnum(LinkTargetType),
  goToType: z.nativeEnum(GoToType).nullable(),
  isDecorative: z.boolean()
});

export type ImageWidgetStaticSchemaType = z.infer<typeof ImageWidgetStaticSchema>;
